module.exports = __webpack_public_path__ + "img/25.baa17d6e.png";